import Vue from 'vue'

export default Vue.extend({
  name: 'ConfirmDialog',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: 'Confirm dialog sample'
    },
    description: {
      type: String,
      default: ''
    },
    confirm: {
      type: String,
      default: 'OK'
    },
    confirmColor: {
      type: String,
      default: 'green'
    },
    maxWidth: {
      type: Number,
      default: 350
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    submit () {
      this.$emit('submit')
      this.close()
    }
  }
})
